import React from 'react';
import PropTypes from 'prop-types';
import Gateways from 'components/widgets/autocompletes/flightGateways';
import DatePicker from 'components/widgets/datePicker';
import TimeSelect from 'components/widgets/autocompletes/select';
import { getTimes } from 'helpers/getTime';
import ErrorTooltip from 'components/snippets/errorTooltip';
import uniqueID from 'helpers/uniqueID';
import moment from 'moment';

const FlightOpenJaw = (props) => {
    const {
        legs,
        errors,
        onChange,
        swapLocations,
    } = props;

    const selectDeparture = (value, element) => {
        const parts = element.split('-');
        const index = legs.findIndex((leg) => leg.key === parts[1]);
        const leg = Object.assign({}, legs[index]);
        leg.departure = value;
        const newLegs = [...legs.slice(0, index), leg, ...legs.slice(index + 1)];
        onChange(newLegs, element);
    };

    const selectDestination = (value, element) => {
        const parts = element.split('-');
        const index = legs.findIndex((leg) => leg.key === parts[1]);
        const leg = Object.assign({}, legs[index]);
        leg.destination = value;
        const newLegs = [...legs.slice(0, index), leg, ...legs.slice(index + 1)];
        onChange(newLegs, element);
    };

    const onDateChange = (date, element) => {
        const parts = element.split('-');
        const index = legs.findIndex((leg) => leg.key === parts[1]);
        const leg = Object.assign({}, legs[index]);

        if (leg.startDate) {
            const startDateValue = leg.startDate.format('YYYY-MM-DDTHH:mm:ss');
            const startDateTime = date.format('YYYY-MM-DD') + startDateValue.slice(10);
            leg.startDate = moment(startDateTime, 'YYYY-MM-DDTHH:mm:ss');
        } else {
            leg.startDate = date;
        }

        const newLegs = [...legs.slice(0, index), leg, ...legs.slice(index + 1)];
        onChange(newLegs, element);
    };

    const onDepartTimeChange = (departTime, element) => {
        const parts = element.split('-');
        const index = legs.findIndex((leg) => leg.key === parts[1]);
        const leg = Object.assign({}, legs[index]);

        if (leg.startDate) {
            const startDatetime = `${leg.startDate.format('YYYY-MM-DD')} ${moment(departTime.text, 'hh:mm A').format('HH:mm:ss')}`;
            leg.startDate = moment(startDatetime, 'YYYY-MM-DDTHH:mm:ss');
        }
        leg.departTime = departTime;
        const newLegs = [...legs.slice(0, index), leg, ...legs.slice(index + 1)];
        onChange(newLegs, element);
    };

    const times = getTimes();

    return (
        <>
            <div className="col-12 col-md-6 col-lg-6 going-to">
                <div className="element-container">
                    <div className="row gutter-0">
                        <div className="col">
                            <div className="">
                                <label className="text-label" htmlFor="flt_departure_openjaw_0">From</label>
                                <div className="element-wrapper">
                                    <Gateways
                                        id="flt_departure_openjaw_0"
                                        placeholder="Select a location"
                                        onSelect={(value) => { selectDeparture(value, `departure-${legs[0].key}`); }}
                                        value={legs[0].departure}
                                    />
                                    {errors && errors[`departure-${legs[0].key}`] && (
                                        <ErrorTooltip error={{ message: errors[`departure-${legs[0].key}`], id: 'departure' }} />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="">
                                <label className="text-label" htmlFor="flt_destination_openjaw_0">To</label>
                                <div className="element-wrapper">
                                    <button className="btn-unstyled border btn-switch" type="button" onClick={() => swapLocations(0)}>
                                        <div className="icon-container">
                                            <svg className="icon mt-xl-1 primary-color" width="100%" height="100%" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                <use xlinkHref="/img/icons/icon-defs.svg#icon-half-right-left-arrow" />
                                            </svg>
                                        </div>
                                    </button>
                                    <Gateways
                                        id="flt_destination_openjaw_0"
                                        placeholder="Select a location"
                                        onSelect={(value) => { selectDestination(value, `destination-${legs[0].key}`); }}
                                        value={legs[0].destination}
                                    />
                                    {errors && errors[`destination-${legs[0].key}`] && (
                                        <ErrorTooltip error={{ message: errors[`destination-${legs[0].key}`], id: 'destination' }} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xxl-3 duration">
                <div className="element-container date-select-container">
                    <div className="row gutter-0">
                        <div className="col">
                            <div className="cldr_container single-date-picker">
                                <DatePicker
                                    dateId="flt_departureDate"
                                    minDate={1}
                                    label="Departure"
                                    datePlaceholderText="Select Date"
                                    date={legs[0].startDate}
                                    onDateChange={(date) => { onDateChange(date, `date-${legs[0].key}`); }}
                                />
                                {errors && errors[`date-${legs[0].key}`] && (
                                    <ErrorTooltip error={{ message: errors[`date-${legs[0].key}`], id: 'date' }} />
                                )}
                            </div>
                        </div>
                        <div className="col">
                            <div className="input-chevron-down">
                                <div className="element-wrapper">
                                    <label className="text-label" htmlFor="flt_departTime">Time</label>
                                    <TimeSelect
                                        id="flt_departTime"
                                        value={legs[0].departTime}
                                        options={times}
                                        name="departTime"
                                        placeholder="Select Time"
                                        onSelect={(departTime) => onDepartTimeChange(departTime, `date-${legs[0].key}`)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 going-to">
                <div className="element-container">
                    <div className="row gutter-0">
                        <div className="col">
                            <div className="">
                                <label className="text-label" htmlFor="flt_departure_openjaw_1">From</label>
                                <div className="element-wrapper">
                                    <Gateways
                                        id="flt_departure_openjaw_1"
                                        placeholder="Select a location"
                                        onSelect={(value) => { selectDeparture(value, `departure-${legs[1].key}`); }}
                                        value={legs[1].departure}
                                    />
                                    {errors && errors[`departure-${legs[1].key}`] && (
                                        <ErrorTooltip error={{ message: errors[`departure-${legs[1].key}`], id: 'departure' }} />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="">
                                <label className="text-label" htmlFor="flt_destination_openjaw_1">To</label>
                                <div className="element-wrapper">
                                    <button className="btn-unstyled border btn-switch" type="button" onClick={() => swapLocations(1)}>
                                        <div className="icon-container">
                                            <svg className="icon mt-xl-1 primary-color" width="100%" height="100%" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                <use xlinkHref="/img/icons/icon-defs.svg#icon-half-right-left-arrow" />
                                            </svg>
                                        </div>
                                    </button>
                                    <Gateways
                                        id="flt_destination_openjaw_1"
                                        placeholder="Select a location"
                                        onSelect={(value) => { selectDestination(value, `destination-${legs[1].key}`); }}
                                        value={legs[1].destination}
                                    />
                                    {errors && errors[`destination-${legs[1].key}`] && (
                                        <ErrorTooltip error={{ message: errors[`destination-${legs[1].key}`], id: 'destination' }} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xxl-3 duration">
                <div className="element-container date-select-container">
                    <div className="row gutter-0">
                        <div className="col">
                            <div className="cldr_container single-date-picker">
                                <DatePicker
                                    dateId="flt_departureDate"
                                    minDate={1}
                                    label="Departure"
                                    datePlaceholderText="Select Date"
                                    date={legs[1].startDate}
                                    onDateChange={(date) => { onDateChange(date, `date-${legs[1].key}`); }}
                                />
                                {errors && errors[`date-${legs[1].key}`] && (
                                    <ErrorTooltip error={{ message: errors[`date-${legs[1].key}`], id: 'date' }} />
                                )}
                            </div>
                        </div>
                        <div className="col">
                            <div className="input-chevron-down">
                                <div className="element-wrapper">
                                    <label className="text-label" htmlFor="flt_departTime">Time</label>
                                    <TimeSelect
                                        id="flt_departTime"
                                        value={legs[1].departTime}
                                        options={times}
                                        name="departTime"
                                        placeholder="Select Time"
                                        onSelect={(departTime) => onDepartTimeChange(departTime, `date-${legs[1].key}`)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

FlightOpenJaw.propTypes = {
    legs: PropTypes.instanceOf(Array).isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.instanceOf(Object),
    swapLocations: PropTypes.instanceOf(Object).isRequired,
};

FlightOpenJaw.defaultProps = {
    errors: {},
};

export default FlightOpenJaw;
